import React from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import './style.datepicker.css';

class MokaDatePicker extends React.Component {
  render() {
    const {
      input,
      meta: { touched, error },
      className,
      minDate,
      placeholder = 'Payment Date',
      readOnly = true,
      showMonthDropdown = false,
      showYearDropdown = false,
      errorClassName,
    } = this.props;
    return (
      <div>
        <DatePicker
          {...input}
          dateFormat="DD/MM/YYYY"
          onBlur={() => input.onBlur()}
          selected={input.value ? moment(input.value) : null}
          placeholderText={placeholder}
          className={className}
          maxDate={moment()}
          minDate={minDate}
          readOnly={readOnly}
          showMonthDropdown={showMonthDropdown}
          showYearDropdown={showYearDropdown}
          dropdownMode="select"
        />
        {touched && error && <span className={errorClassName}>{error}</span>}
      </div>
    );
  }
}

export default MokaDatePicker;
